export const AlternativeTheme = {

    primaryColor: '#3525ec',
    primaryFont: 'DM Serif Display',

    secondaryColor: '#fff',

    fontSizeMedium: '12px',

    lightGrease: '#F9FBFC',
    grease: '#EAF1F3',

    urlLogoHorizontal: 'url("assets/logo-mapfre-horizontal.png")',
    urlLogoVertical: 'url("assets/logo-mapfre-vertical.png")',

    headerTextColor: '#fff',
    headerWidthLogo: '150px',

    loginHeightLogo: '75px',

    baseBorderRadius: '0px'
}